/* Ripe & Ready — smooth <details> panels.

   A native <details> snaps open in one frame. There is no CSS that fixes that
   on its own: the panel goes from display:none to display:block, a transition
   cannot run across that, and a keyframe cannot measure content it has not
   laid out yet.

   So the height is animated here instead. Growing the height from zero is what
   makes the box's bottom border slide down, which is the part that reads as
   "opening" rather than "appearing".

   Without this script the panel still works. It just opens at once, which is
   the correct fallback.

   Markup: sections/rr-week.liquid (.wk-drop)
   Styles: assets/rr-base.css (.wk-drop, .wk-drop-body)
*/
(function () {
  "use strict";

  var DURATION = 320;
  var EASE = "cubic-bezier(0.22, 0.61, 0.36, 1)";

  function reduced() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function setup(details) {
    var summary = details.querySelector("summary");
    var body = details.querySelector(".wk-drop-body");
    if (!summary || !body || typeof body.animate !== "function") {
      return;
    }

    /* One animation at a time. Clicking twice quickly must not leave the panel
       stuck at half height with a finished animation holding it there. */
    var running = null;

    /* The padding has to travel with the height. Height alone animates from
       zero, but the padding stays at full size the whole way, so the panel
       jumps open by the padding and only then starts to grow. Measured at
       30px of jump before this was added. */
    function pad() {
      var cs = getComputedStyle(body);
      return { top: cs.paddingTop, bottom: cs.paddingBottom };
    }

    function frame(h, o, p) {
      return { height: h, opacity: o, paddingTop: p.top, paddingBottom: p.bottom };
    }

    var ZERO = { top: "0px", bottom: "0px" };

    function play(frames, after) {
      if (running) {
        running.cancel();
      }
      running = body.animate(frames, { duration: DURATION, easing: EASE });
      running.onfinish = function () {
        running = null;
        if (after) {
          after();
        }
      };
    }

    summary.addEventListener("click", function (e) {
      /* The browser would toggle the open attribute itself and skip straight to
         the end state, so take the click and drive it by hand. */
      e.preventDefault();

      if (reduced()) {
        details.open = !details.open;
        return;
      }

      var p = pad();

      if (!details.open) {
        details.open = true;
        /* scrollHeight is the border-box height here, because the page sets
           box-sizing: border-box on everything, so it already counts the
           padding we are animating back in. */
        var target = body.scrollHeight;
        play([frame("0px", 0, ZERO), frame(target + "px", 1, p)]);
      } else {
        var start = body.scrollHeight;
        play([frame(start + "px", 1, p), frame("0px", 0, ZERO)], function () {
          details.open = false;
        });
      }
    });
  }

  function start() {
    var all = document.querySelectorAll("details.wk-drop");
    for (var i = 0; i < all.length; i++) {
      setup(all[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
